import React from "react";
import { Quote, ArrowRight } from "lucide-react";

// Only real, approved social proof. The MBN Solutions quote and the Donorbox
// case study are both published on gdprlocal.com. No fabricated attributions.
export const Testimonials = () => (
  <section className="border-t hairline" data-testid="testimonials">
    <div className="max-w-[1240px] mx-auto px-5 lg:px-8 py-16">
      <div className="max-w-2xl">
        <span className="text-[12.5px] font-bold uppercase tracking-wide text-mutedink">In their words</span>
        <h2 className="mt-2 text-3xl lg:text-4xl font-bold text-asphalt">Trusted by teams who take this seriously</h2>
      </div>

      <div className="mt-10 grid lg:grid-cols-2 gap-6">
        <figure className="rounded-2xl border hairline bg-white p-7" data-testid="testimonial-mbn">
          <Quote size={28} color="#2FE1EC" />
          <blockquote className="mt-4 text-[16px] text-asphalt leading-relaxed">
            Working with GDPRLocal has been a game-changer for MBN Solutions. Their professionalism and expertise ensure our data is safe. They offer first-class service and a great customer experience. MBN Solutions highly recommends GDPRLocal for any business needing GDPR solutions.
          </blockquote>
          <figcaption className="mt-5 flex items-center gap-3">
            <span className="w-10 h-10 rounded-full flex items-center justify-center font-bold text-[13px]" style={{ background: "#EEF2F6", color: "#364F6B" }}>FG</span>
            <span>
              <span className="block font-bold text-asphalt text-[14px]">Fiona Gillies</span>
              <span className="block text-[13px] text-mutedink">Operations Manager, MBN Solutions</span>
            </span>
          </figcaption>
        </figure>

        <a
          href="https://gdprlocal.com/case-study/the-privacy-edge-how-donorbox-gained-22-growth-with-gdprlocal/"
          className="group rounded-2xl border-2 hairline hover:border-aqua transition-colors p-7 flex flex-col justify-between bg-white"
          data-testid="case-study-donorbox"
        >
          <div>
            <span className="text-[12px] font-bold uppercase tracking-wide" style={{ color: "#2FE1EC" }}>Case study</span>
            <h3 className="mt-2 text-xl font-bold text-asphalt leading-snug">The Privacy Edge: how Donorbox gained 22% growth with GDPRLocal</h3>
            <p className="mt-3 text-[14px] text-mutedink leading-relaxed">
              How an investor-ready approach to data protection turned compliance into a growth advantage.
            </p>
          </div>
          <span className="mt-6 inline-flex items-center gap-1.5 font-medium text-asphalt group-hover:gap-2.5 transition-all">
            Read their story <ArrowRight size={16} />
          </span>
        </a>
      </div>
    </div>
  </section>
);
